













import Vue from 'vue'

import selectBody from './body/select-body.vue'
import defaultList from './lists/default-list.vue'

import { DefaultListModel } from './types'

export default Vue.extend({
    name: 'select-searchable-default',
    components: {
        selectBody,
        defaultList
    },
    props: {
        list: Array,
        keyword: String,
        placeholder: String,
        currentValue: {} as () => DefaultListModel
    },
    methods: {
        select(value: DefaultListModel): void {
            this.$emit('select', value);
        },
    }
})
